<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="grid-view"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <div class="main-content">
      <div class="app-main-inner-row">
        <div class="filters" />
        <div class="triggers">
          <el-button type="primary" size="mini" @click="popTemplateTypeAddDialog">
            {{ $t('common.btn.new') }}
          </el-button>
          <el-button type="primary" size="mini" @click="popTemplateTypeEditFormDialog">
            {{ $t('common.btn.edit') }}
          </el-button>
          <el-button type="danger" size="mini" @click="toBatchDel">
            {{ $t('common.btn.delete') }}
          </el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-options="gridOptions"
          :side-bar="sideBarDefs"
          style="width: 100%;"
          @gridReady="onReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="loadData"
        />
      </div>
    </div>
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="isShowTemplateTypeManagementMaintain"
      :title="showTemplateTypeManagementMaintainTitle"
      inline-message
      width="600px"
    >
      <el-form
        ref="templateTypeManagementMaintainForm"
        :model="templateTypeManagementForm"
        label-width="150px"
        label-position="right"
      >
        <el-form-item label="DEFAULT ENGINE">
          <el-radio-group v-model="templateTypeManagementForm.defaultEngine">
            <el-radio :label="0">V1</el-radio>
            <el-radio :label="1">V2</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="SCHEMA TYPE">
          <el-input ref="schemaType" v-model="templateTypeManagementForm.schemaType" size="mini" />
        </el-form-item>
        <el-form-item label="TEMPLATE TYPE">
          <el-input ref="templateType" v-model="templateTypeManagementForm.templateType" size="mini" />
        </el-form-item>
        <el-form-item label="TEMPLATE TYPE DESC">
          <el-input ref="templateTypeDesc" v-model="templateTypeManagementForm.templateTypeDesc" size="mini" />
        </el-form-item>
        <el-form-item label="REMARKS">
          <el-input v-model="templateTypeManagementForm.remarks" type="textarea" rows="2" size="mini" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini " type="primary" @click="submitTemplateTypeManagement">{{ $t('common.btn.save') }}</el-button>
        <el-button size="mini " @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as templateTypeApi from '@/api/sysManage/baseConfig/templateType'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'TemplateTypeManagement',
  components: {
    cargoAdvanceSelect
  },
  data() {
    return {
      fullscreenLoading: false,
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: 'DEFAULT_ENGINE',
          field: 'defaultEngine',
          valueFormatter: params => {
            return this.engineLabelFunc(params.value)
          }
        }, {
          headerName: 'SCHEMA_TYPE',
          field: 'schemaType'
        }, {
          headerName: 'TEMPLATE_TYPE',
          field: 'templateType'
        }, {
          headerName: 'TEMPLATE_TYPE_DESC',
          field: 'templateTypeDesc',
          width: 200
        }, {
          headerName: 'REMARKS',
          field: 'remarks'
        }, {
          headerName: 'DATE_MODIFIED',
          field: 'dateModified',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: 'DATE_CREATED',
          field: 'dateCreated',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      gridOptions: {
        rowClassRules: {
          'grid-row-zebra-even': function(params) {
            return !(params.rowIndex % 2)
          },
          'grid-row-zebra-odd': function(params) {
            return (params.rowIndex % 2)
          }
        },
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        paginationNumberFormatter: function(params) {
          return '[' + params.value.toLocaleString() + ']'
        }
      },
      isShowTemplateTypeManagementMaintain: false,
      showTemplateTypeManagementMaintainTitle: '',
      templateTypeManagementForm: {
        defaultEngine: 0,
        schemaType: '',
        templateType: '',
        templateTypeDesc: '',
        remarks: ''
      },
      total: 0,
      filter: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      const loading = getLoading()
      templateTypeApi.getTemplateTypeList(this.filter).then(resp => {
        this.rowData = resp.data.list
        this.total = Number(resp.data.total)
        this.filter.pageNum = resp.data.pageNum
        this.filter.pageSize = resp.data.pageSize
      }).finally(() => loading.close())
    },
    popTemplateTypeAddDialog() {
      this.isShowTemplateTypeManagementMaintain = true
      this.showTemplateTypeManagementMaintainTitle = ' '
    },
    popTemplateTypeEditFormDialog() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      Object.assign(this.templateTypeManagementForm, selectedRow)
      this.showTemplateTypeManagementMaintainTitle = this.$t('CargoMsg.Cargo_Edit')
      this.isShowTemplateTypeManagementMaintain = true
    },
    toBatchDel() {
      const airArray = this.getTemplateTypeSelected()
      if (airArray && airArray.length > 0) {
        this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          // 删除模板类型
          const uuids = airArray.map(el => el.uuid)
          const loading = getLoading()
          templateTypeApi.batchRemove(uuids).then(resp => {
            this.loadData()
          }).finally(() => loading.close())
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.tips.cancelDelete')
          })
        })
      }
    },
    getTemplateTypeSelected() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return null
      }
      return selectedRows
    },
    submitTemplateTypeManagement() {
      if (this.validTemp()) {
        // 保存
        const loading = getLoading()
        templateTypeApi.save(this.templateTypeManagementForm).then(resp => {
          this.cancelSaveOrEdit()
          this.loadData()
        }).finally(() => loading.close())
      }
    },
    validTemp() {
      const { schemaType, templateType, templateTypeDesc } = { ...this.templateTypeManagementForm }
      if (!schemaType) {
        this.$message.warning('Schema Type不能为空.')
        this.$refs.schemaType.focus()
        return false
      }
      if (!templateType) {
        this.$message.warning(this.$t('SystemMaintenance.TemplateTypeCannotBeEmpty'))
        this.$refs.templateType.focus()
        return false
      }
      if (!templateTypeDesc) {
        this.$message.warning(this.$t('SystemMaintenance.TemplateDescCannotBeEmpty'))
        this.$refs.templateTypeDesc.focus()
        return false
      }
      return true
    },
    cancelSaveOrEdit() {
      this.isShowTemplateTypeManagementMaintain = false
      this.templateTypeManagementForm = {
        defaultEngine: 0,
        schemaType: '',
        templateType: '',
        templateTypeDesc: '',
        remarks: ''
      }
    },
    engineLabelFunc(value) {
      let s = '-'
      if (value === 0) {
        s = 'V1'
      } else if (value === 1) {
        s = 'V2'
      }
      return s
    }
  }
}
</script>

<style scoped>

</style>
